import { Component, Input } from "@angular/core";

import { NzI18nService } from "ng-zorro-antd/i18n";
import { UiDateHelperService } from "@webapp/ui/date-picker/services/date-helper.service";
import { UiCalendarInterface } from "@webapp/ui/date-picker/date-picker.models";
import { ɵDateTableComponent as DateTableComponent } from "ng-zorro-antd/date-picker";

@Component({
  selector: "ui-date-table",
  exportAs: "uiDateTable",
  templateUrl: "./date-table.component.html",
})
export class UiDateTableComponent extends DateTableComponent {
  @Input("uiLocale")
  public locale!: UiCalendarInterface;

  constructor(i18n: NzI18nService, dateHelper: UiDateHelperService) {
    super(i18n, dateHelper);
  }
}
